import { FieldRenderProps } from "react-final-form";
import React from "react";
import { Tooltip } from "@material-ui/core";

const truncString = (str: string, n: number) => {
  return str.length > n ? str.substr(0, n - 1) + " ..." : str;
};

const styles = {
  tooltip: {
    whiteSpace: "pre-wrap",
    wordBreak: "keep-all",
    fontSize: 13
  } as React.CSSProperties,
  field: {
    wordBreak: "break-word"
  } as React.CSSProperties
};

export const DefaultPresentationField = () => {
  return (props: FieldRenderProps<any>) => {
    let input = props.input.value;

    if (input && Array.isArray(input)) {
      input = input.join(", ");
    }

    const resultString = "" + input !== undefined ? input : "";

    if (resultString.length > 120) {
      return (
        <Tooltip title={<pre style={styles.tooltip}>{resultString}</pre>}>
          <div style={styles.field}>{truncString(resultString, 120)}</div>
        </Tooltip>
      );
    } else {
      return <div style={styles.field}>{resultString}</div>;
    }
  };
};
